import apolloClient from '../../apolloClient';
import serviceOrderQueries from '../queries/serviceOrders';
import serviceOrderMutations from '../mutations/serviceOrders';

const getServiceOrdersByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: serviceOrderQueries.GET_SERVICE_ORDERS,
    variables,
    fetchPolicy: 'no-cache',
  });

const createServiceOrderStatus = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.CREATE_SERVICE_ORDER_STATUS,
    variables,
    fetchPolicy: 'no-cache',
  });

const updateServiceOrderStatus = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.UPDATE_SERVICE_ORDER_STATUS,
    variables,
    fetchPolicy: 'no-cache',
  });

const deleteServiceOrderStatus = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.DELETE_SERVICE_ORDER_STATUS,
    variables,
    fetchPolicy: 'no-cache',
  });

const createServiceOrder = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.CREATE_SERVICE_ORDER,
    variables,
    fetchPolicy: 'no-cache',
  });

const updateServiceOrderById = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.UPDATE_SERVICE_ORDER_BY_ID,
    variables,
    fetchPolicy: 'no-cache',
  });

const deleteServiceOrderById = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.DELETE_SERVICE_ORDER_BY_ID,
    variables,
    fetchPolicy: 'no-cache',
  });

const addServiceOrderLog = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.ADD_SERVICE_ORDER_LOG,
    variables,
    fetchPolicy: 'no-cache',
  });

const addServiceOrderSubTask = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.ADD_SERVICE_ORDER_SUBTASK,
    variables,
    fetchPolicy: 'no-cache',
  });

const updateServiceOrderSubTask = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.UPDATE_SERVICE_ORDER_SUBTASK,
    variables,
    fetchPolicy: 'no-cache',
  });

const deleteServiceOrderSubTask = async (variables) =>
  apolloClient.mutate({
    mutation: serviceOrderMutations.DELETE_SERVICE_ORDER_SUBTASK,
    variables,
    fetchPolicy: 'no-cache',
  });

export default {
  getServiceOrdersByWorkspaceId,
  createServiceOrderStatus,
  updateServiceOrderStatus,
  deleteServiceOrderStatus,
  createServiceOrder,
  updateServiceOrderById,
  deleteServiceOrderById,
  addServiceOrderLog,
  addServiceOrderSubTask,
  updateServiceOrderSubTask,
  deleteServiceOrderSubTask,
};
